export const financeConfig = {
    card: {
        minDepositPercent: 10, // %
        minDepositValue: 100, // £
        sliderStart: 100, // %
        sliderIncrement: 5 // £
    },
    // Interest free credit (IFC).
    ifc: {
        monthlySliderStart: 12, // months
        monthlySliderIncrement: 1, // month
        depositSliderIncrement: 50, // £
        // TODO: move to ifc-configuration-api
        fixedValues: {
            maxBalanceAmount: 15000, // £
            minBalanceAmount: 500 // £
        }
    }
};